<template>
  <div class="productMultiPacksList">
    <div class="productMultiPacksList__item" v-for="option in options" :key="option.id">
      <template v-if="isMounted">
        <nuxt-link
          :to="localePath({ name: 'product-slug', params: { slug: option.slug } })"
          :class="[
            'productMultiPacksList__option',
            { 'productMultiPacksList__option--active': product.id === option.id },
          ]"
          offset="20"
          v-v-tooltip="{
            content: `${
              showNetPrices
                ? `<div><b>${option.priceObject.netFormatted}</b> ${
                    option.priceObject.currencyPostfix
                  } netto</div>
                 <div style='text-align: center'>${
                   option.discount ? `<span class='redBox'>${option.discount}%</span> ` : ''
                 }<b>${option.unitPrice.netFormatted}</b>/${option.uom}</div>`
                : `<div><b>${option.priceObject.grossFormatted}</b> ${
                    option.priceObject.currencyPostfix
                  } brutto</div>
                <div style='text-align: center'>${
                  option.discount ? `<span class='redBox'>${option.discount}%</span> ` : ''
                }<b>${option.unitPrice.grossFormatted}</b>/${option.uom}</div>`
            }`,
            offset: 10,
          }"
        >
          <div class="productMultiPacksList__optionImage">
            <NewImageBox
              :alt="option.name"
              :src="option.mainPictureUrl"
              :width="150"
              :height="150"
              fit-contain-center
              image-params="w_150,h_150"
            />
          </div>
          <div class="productMultiPacksList__optionQuantity">
            {{ option.quantity }} {{ option.uom }}
          </div>
        </nuxt-link>
      </template>
      <nuxt-link
        v-else
        :to="localePath({ name: 'product-slug', params: { slug: option.slug } })"
        :class="[
          'productMultiPacksList__option',
          { 'productMultiPacksList__option--active': product.id === option.id },
        ]"
      >
        <div class="productMultiPacksList__optionImage">
          <NewImageBox
            :alt="option.name"
            :src="option.mainPictureUrl"
            :width="60"
            :height="60"
            fit-contain-center
            image-params="w_60,h_60"
          />
        </div>
        <div class="productMultiPacksList__optionQuantity">
          {{ option.quantity }} {{ option.uom }}
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import { VClosePopover, VPopover, VTooltip } from 'v-tooltip';
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import NewImageBox from '@/components/NewImageBox.vue';
import IconButton from '@/components/IconButton.vue';

export default {
  name: 'ProductMultiPacksList',
  components: { IconButton, NewImageBox, Multiselect, VPopover },
  directives: {
    closePopover: VClosePopover,
    vTooltip: VTooltip,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      isMounted: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['showNetPrices']),
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    gTagProductClick(item) {
      const categories = this.product.category.namesInPath.reduce((acc, curr, index) => {
        acc['category' + (index === 0 ? '' : index + 1)] = curr;
        return acc;
      }, {});
      this.$gtm.push({ ecommerce: null });
      this.$gtm.push({
        event: 'select_item',
        ecommerce: {
          item_list_id: '',
          item_list_name: '',
          items: [
            {
              item_id: item.id,
              item_name: item.name,
              discount: item.discount ? item.discount : 0,
              brand: this.product.brand ? this.product.brand.name : '',
              ...categories,
              promotion_id: item?.promotion?.id ?? '',
              promotion_name: item?.promotion?.name ?? '',
              item_list_id: '',
              item_list_name: '',
              price: item.gross,
              variant: '',
              quantity: 1,
            },
          ],
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.productMultiPacksList {
  $root: &;
  display: flex;
  margin: 0 -0.7rem;

  &__item {
    display: flex;
    padding: 0 0.7rem;
  }

  &__optionImage {
    position: relative;
    aspect-ratio: 1 / 1;
    border: 1px solid $cAddLight;
    padding: 0.5rem;
    border-radius: 4px;
  }

  &__item {
    flex: 0 0 25%;
    max-width: 25%;
  }

  &__option {
    display: block;
    position: relative;
    width: 100%;

    &--active {
      #{$root}__optionImage {
        border: 2px solid $cSec;
      }
    }
  }

  &__optionQuantity {
    text-align: center;
    font-size: 1.2rem;
    color: $cMainNeutral;
    margin-top: 0.5rem;
  }
}
</style>
